import { render, staticRenderFns } from "./statusled.vue?vue&type=template&id=de45e5ca&"
import script from "./statusled.vue?vue&type=script&lang=js&"
export * from "./statusled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports